// El idioma del contenido de cada marca (pregunta de «Tu negocio» y cómo se muestra).
export default {
  '¿En qué idioma quieres tu contenido?': 'What language do you want your content in?',
  'El de tus clientes, según dónde vendes: tus posts, guiones y videos salen en ese idioma. IGOR te sigue explicando todo en el tuyo.':
    "Your customers' language, based on where you sell: your posts, scripts and videos come out in it. IGOR keeps explaining everything to you in yours.",
  Español: 'Spanish',
  Inglés: 'English',
  'Inglés de Estados Unidos': 'US English',
  'Inglés británico': 'British English',
  'Inglés neutro': 'Neutral English',
} satisfies Record<string, string>;
